// extracted by mini-css-extract-plugin
export default {"root":"q_zhZVK46J"};